module.exports = __webpack_public_path__ + "img/icon-facebook.a0132c6f312e21fdcdfcb970453b904e.svg";